// Translates the Manual Coverage table cells. The sheet is English and shares a
// small vocabulary, so cells are composed from terms instead of keeping 38 rows
// per language. Manual numbers and model / engine codes are identifiers and stay
// as they are.

const DATE_LOCALES = {
  Japanese: 'ja',
  Indonesian: 'id',
  Nepali: 'ne-u-nu-latn',
  Sinhala: 'si',
  Vietnamese: 'vi',
  Filipino: 'fil',
  Bengali: 'bn-u-nu-latn',
};

const volumeName = {
  Japanese: (n) => `第${n}巻`,
  Indonesian: (n) => `Jilid ${n}`,
  Nepali: (n) => `खण्ड ${n}`,
  Sinhala: (n) => `වෙළුම ${n}`,
  Vietnamese: (n) => `Tập ${n}`,
  Filipino: (n) => `Tomo ${n}`,
  Bengali: (n) => `খণ্ড ${n}`,
};

// Longest phrases first, so a term never breaks a longer phrase that contains it.
const TERMS = {
  Japanese: [
    ['2017 initial set (cover carries no model-year label)', '2017年初版（表紙に年式表記なし）'],
    ['revised edition incl. service news updates', 'サービスニュースの更新を含む改訂版'],
    ['later service news revisions incorporated', '以降のサービスニュース改訂を反映'],
    ['other details to be confirmed', 'その他の詳細は確認中'],
    ['Details to be confirmed', '詳細は確認中'],
    ['Kindergarten Bus Dedicated Equipment', '幼児バス専用装置'],
    ['26-Model Dedicated Equipment', '26モデル専用装置'],
    ['21-Model Dedicated Equipment', '21モデル専用装置'],
    ['Advanced Service Information', '高度整備情報'],
    ['Later 19-model edition', '19モデル後期版'],
    ['Full revised set', '全面改訂版'],
    ['published for 17MP', '17MPでは未発行'],
    ['covers eCanter', 'eCanterを収録'],
    ['full trailer', 'フルトレーラ'],
    ['Adv. Info', '高度整備情報'],
    ['Low-Floor', '低床'],
    ['EV System', 'EVシステム'],
    ['Engines', 'エンジン'],
    ['Engine', 'エンジン'],
    ['Electric', '電気'],
    ['Wave 1', '第1弾'],
    ['issued', '発行'],
    ['excl.', '除く'],
    ['(all)', '（全車）'],
    ['No ', ''],
    ['TBC', '確認中'],
    ['Aero Queen', 'エアロクィーン'],
    ['Aero Ace', 'エアロエース'],
    ['Aero Star', 'エアロスター'],
    ['Super Great', 'スーパーグレート'],
    ['Rosa', 'ローザ'],
    ['Canter', 'キャンター'],
    ['Fighter', 'ファイター'],
  ],
  Indonesian: [
    ['2017 initial set (cover carries no model-year label)', 'Set awal 2017 (sampul tanpa label tahun model)'],
    ['revised edition incl. service news updates', 'edisi revisi termasuk pembaruan berita servis'],
    ['later service news revisions incorporated', 'revisi berita servis berikutnya telah disertakan'],
    ['other details to be confirmed', 'detail lain akan dikonfirmasi'],
    ['Details to be confirmed', 'Detail akan dikonfirmasi'],
    ['Kindergarten Bus Dedicated Equipment', 'Perlengkapan Khusus Bus TK'],
    ['26-Model Dedicated Equipment', 'Perlengkapan Khusus Model 26'],
    ['21-Model Dedicated Equipment', 'Perlengkapan Khusus Model 21'],
    ['Advanced Service Information', 'Informasi Servis Lanjutan'],
    ['Later 19-model edition', 'Edisi model 19 yang lebih baru'],
    ['Full revised set', 'Set revisi lengkap'],
    ['published for 17MP', 'tidak diterbitkan untuk 17MP'],
    ['covers eCanter', 'mencakup eCanter'],
    ['full trailer', 'trailer penuh'],
    ['Adv. Info', 'Info Lanjutan'],
    ['Low-Floor', 'Lantai Rendah'],
    ['EV System', 'Sistem EV'],
    ['Engines', 'Mesin'],
    ['Engine', 'Mesin'],
    ['Electric', 'Listrik'],
    ['Wave 1', 'Gelombang 1'],
    ['issued', 'terbit'],
    ['excl.', 'kecuali'],
    ['(all)', '(semua)'],
    ['No ', ''],
    ['TBC', 'Akan dikonfirmasi'],
  ],
  Nepali: [
    ['2017 initial set (cover carries no model-year label)', '2017 को प्रारम्भिक सेट (आवरणमा मोडेल वर्ष छैन)'],
    ['revised edition incl. service news updates', 'सर्भिस न्युज अद्यावधिकसहितको संशोधित संस्करण'],
    ['later service news revisions incorporated', 'पछिल्ला सर्भिस न्युज संशोधनहरू समावेश'],
    ['other details to be confirmed', 'अन्य विवरण पुष्टि हुन बाँकी'],
    ['Details to be confirmed', 'विवरण पुष्टि हुन बाँकी'],
    ['Kindergarten Bus Dedicated Equipment', 'किन्डरगार्टन बस विशेष उपकरण'],
    ['26-Model Dedicated Equipment', '26-मोडेल विशेष उपकरण'],
    ['21-Model Dedicated Equipment', '21-मोडेल विशेष उपकरण'],
    ['Advanced Service Information', 'उन्नत सेवा जानकारी'],
    ['Later 19-model edition', 'पछिल्लो 19-मोडेल संस्करण'],
    ['Full revised set', 'पूर्ण संशोधित सेट'],
    ['published for 17MP', '17MP का लागि प्रकाशित छैन'],
    ['covers eCanter', 'eCanter समेट्छ'],
    ['full trailer', 'पूर्ण ट्रेलर'],
    ['Adv. Info', 'उन्नत जानकारी'],
    ['Low-Floor', 'लो-फ्लोर'],
    ['EV System', 'EV प्रणाली'],
    ['Engines', 'इन्जिनहरू'],
    ['Engine', 'इन्जिन'],
    ['Electric', 'विद्युतीय'],
    ['Wave 1', 'चरण 1'],
    ['issued', 'जारी'],
    ['excl.', 'बाहेक'],
    ['(all)', '(सबै)'],
    ['No ', ''],
    ['TBC', 'पुष्टि हुन बाँकी'],
  ],
  Sinhala: [
    ['2017 initial set (cover carries no model-year label)', '2017 මුල් කට්ටලය (කවරයේ මාදිලි වර්ෂය නැත)'],
    ['revised edition incl. service news updates', 'සේවා පුවත් යාවත්කාලීන ඇතුළත් සංශෝධිත සංස්කරණය'],
    ['later service news revisions incorporated', 'පසු සේවා පුවත් සංශෝධන ඇතුළත්'],
    ['other details to be confirmed', 'අනෙකුත් විස්තර තහවුරු කළ යුතුය'],
    ['Details to be confirmed', 'විස්තර තහවුරු කළ යුතුය'],
    ['Kindergarten Bus Dedicated Equipment', 'පෙර පාසල් බස් විශේෂ උපකරණ'],
    ['26-Model Dedicated Equipment', '26 මාදිලි විශේෂ උපකරණ'],
    ['21-Model Dedicated Equipment', '21 මාදිලි විශේෂ උපකරණ'],
    ['Advanced Service Information', 'උසස් සේවා තොරතුරු'],
    ['Later 19-model edition', 'පසු 19 මාදිලි සංස්කරණය'],
    ['Full revised set', 'සම්පූර්ණ සංශෝධිත කට්ටලය'],
    ['published for 17MP', '17MP සඳහා ප්‍රකාශයට පත් කර නැත'],
    ['covers eCanter', 'eCanter ආවරණය කරයි'],
    ['full trailer', 'සම්පූර්ණ ට්‍රේලරය'],
    ['Adv. Info', 'උසස් තොරතුරු'],
    ['Low-Floor', 'පහත් තට්ටු'],
    ['EV System', 'EV පද්ධතිය'],
    ['Engines', 'එන්ජින්'],
    ['Engine', 'එන්ජිම'],
    ['Electric', 'විදුලි'],
    ['Wave 1', 'අදියර 1'],
    ['issued', 'නිකුත් කළේ'],
    ['excl.', 'හැර'],
    ['(all)', '(සියල්ල)'],
    ['No ', ''],
    ['TBC', 'තහවුරු කළ යුතුය'],
  ],
  Vietnamese: [
    ['2017 initial set (cover carries no model-year label)', 'Bộ đầu tiên 2017 (bìa không ghi năm model)'],
    ['revised edition incl. service news updates', 'bản sửa đổi gồm cập nhật tin dịch vụ'],
    ['later service news revisions incorporated', 'đã gồm các sửa đổi tin dịch vụ sau đó'],
    ['other details to be confirmed', 'các chi tiết khác sẽ được xác nhận'],
    ['Details to be confirmed', 'Chi tiết sẽ được xác nhận'],
    ['Kindergarten Bus Dedicated Equipment', 'Thiết bị chuyên dụng xe buýt mẫu giáo'],
    ['26-Model Dedicated Equipment', 'Thiết bị chuyên dụng model 26'],
    ['21-Model Dedicated Equipment', 'Thiết bị chuyên dụng model 21'],
    ['Advanced Service Information', 'Thông tin dịch vụ nâng cao'],
    ['Later 19-model edition', 'Ấn bản model 19 sau'],
    ['Full revised set', 'Bộ sửa đổi đầy đủ'],
    ['published for 17MP', 'không phát hành cho 17MP'],
    ['covers eCanter', 'bao gồm eCanter'],
    ['full trailer', 'rơ moóc toàn phần'],
    ['Adv. Info', 'Thông tin nâng cao'],
    ['Low-Floor', 'Sàn thấp'],
    ['EV System', 'Hệ thống EV'],
    ['Engines', 'Động cơ'],
    ['Engine', 'Động cơ'],
    ['Electric', 'Điện'],
    ['Wave 1', 'Đợt 1'],
    ['issued', 'phát hành'],
    ['excl.', 'trừ'],
    ['(all)', '(tất cả)'],
    ['No ', ''],
    ['TBC', 'Sẽ xác nhận'],
  ],
  Filipino: [
    ['2017 initial set (cover carries no model-year label)', 'Unang set ng 2017 (walang model-year label sa pabalat)'],
    ['revised edition incl. service news updates', 'binagong edisyon kasama ang mga update ng service news'],
    ['later service news revisions incorporated', 'kasama ang mga sumunod na rebisyon ng service news'],
    ['other details to be confirmed', 'kukumpirmahin pa ang ibang detalye'],
    ['Details to be confirmed', 'Kukumpirmahin pa ang mga detalye'],
    ['Kindergarten Bus Dedicated Equipment', 'Espesyal na Kagamitan ng Kindergarten Bus'],
    ['26-Model Dedicated Equipment', 'Espesyal na Kagamitan ng 26-Model'],
    ['21-Model Dedicated Equipment', 'Espesyal na Kagamitan ng 21-Model'],
    ['Advanced Service Information', 'Advanced na Impormasyon sa Serbisyo'],
    ['Later 19-model edition', 'Mas bagong edisyon ng 19-model'],
    ['Full revised set', 'Buong binagong set'],
    ['published for 17MP', 'hindi inilathala para sa 17MP'],
    ['covers eCanter', 'sumasaklaw sa eCanter'],
    ['full trailer', 'buong trailer'],
    ['Adv. Info', 'Advanced na Impormasyon'],
    ['Low-Floor', 'Mababang Sahig'],
    ['EV System', 'EV System'],
    ['Engines', 'Mga Makina'],
    ['Engine', 'Makina'],
    ['Electric', 'De-kuryente'],
    ['Wave 1', 'Unang Bugso'],
    ['issued', 'inilabas'],
    ['excl.', 'maliban sa'],
    ['(all)', '(lahat)'],
    ['No ', ''],
    ['TBC', 'Kukumpirmahin'],
  ],
  Bengali: [
    ['2017 initial set (cover carries no model-year label)', '2017 প্রাথমিক সেট (প্রচ্ছদে মডেল বছর নেই)'],
    ['revised edition incl. service news updates', 'সার্ভিস নিউজ আপডেটসহ সংশোধিত সংস্করণ'],
    ['later service news revisions incorporated', 'পরবর্তী সার্ভিস নিউজ সংশোধন অন্তর্ভুক্ত'],
    ['other details to be confirmed', 'অন্যান্য বিবরণ নিশ্চিত করা হবে'],
    ['Details to be confirmed', 'বিবরণ নিশ্চিত করা হবে'],
    ['Kindergarten Bus Dedicated Equipment', 'কিন্ডারগার্টেন বাসের বিশেষ সরঞ্জাম'],
    ['26-Model Dedicated Equipment', '26-মডেলের বিশেষ সরঞ্জাম'],
    ['21-Model Dedicated Equipment', '21-মডেলের বিশেষ সরঞ্জাম'],
    ['Advanced Service Information', 'উন্নত সার্ভিস তথ্য'],
    ['Later 19-model edition', 'পরবর্তী 19-মডেল সংস্করণ'],
    ['Full revised set', 'সম্পূর্ণ সংশোধিত সেট'],
    ['published for 17MP', '17MP-এর জন্য প্রকাশিত হয়নি'],
    ['covers eCanter', 'eCanter অন্তর্ভুক্ত'],
    ['full trailer', 'পূর্ণ ট্রেলার'],
    ['Adv. Info', 'উন্নত তথ্য'],
    ['Low-Floor', 'লো-ফ্লোর'],
    ['EV System', 'EV সিস্টেম'],
    ['Engines', 'ইঞ্জিন'],
    ['Engine', 'ইঞ্জিন'],
    ['Electric', 'বৈদ্যুতিক'],
    ['Wave 1', 'ধাপ 1'],
    ['issued', 'প্রকাশিত'],
    ['excl.', 'ব্যতীত'],
    ['(all)', '(সকল)'],
    ['No ', ''],
    ['TBC', 'নিশ্চিত করা হবে'],
  ],
};

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const DATE_RE = new RegExp(`\\b(${MONTHS.join('|')}) (\\d{4})\\b`, 'g');
const VOLUME_RE = /\bVols?\. ([0-9A]+(?:[–/][0-9A]+)*)/g;
const NOT_INSIDE_A_WORD = (term) => new RegExp(`(?<![A-Za-z])${term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}`, 'g');

const translateDate = (langOpt) => {
  const format = new Intl.DateTimeFormat(DATE_LOCALES[langOpt], { year: 'numeric', month: 'short', timeZone: 'UTC' });
  return (_, month, year) => format.format(new Date(Date.UTC(Number(year), MONTHS.indexOf(month), 1)));
};

// `localizeCoverageCell` leaves English and any untranslated language unchanged.
export const localizeCoverageCell = (text, langOpt) => {
  if (!TERMS[langOpt] || !text) return text;
  const translated = TERMS[langOpt].reduce(
    (cell, [english, local]) => cell.replace(NOT_INSIDE_A_WORD(english), local),
    text,
  );
  return translated
    .replace(VOLUME_RE, (_, number) => volumeName[langOpt](number))
    .replace(DATE_RE, translateDate(langOpt));
};
